var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/rrTray.j2"] = require( "macros/rrTray.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/multipleRRProductTrays.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/rrTray.j2", false, "category/templates/multipleRRProductTrays.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("richRelevanceTray")) {
var t_4 = t_1.richRelevanceTray;
} else {
cb(new Error("cannot import 'richRelevanceTray'")); return;
}
context.setVariable("richRelevanceTray", t_4);
output += runtime.suppressValue((lineno = 2, colno = 18, runtime.callWrap(t_4, "richRelevanceTray", context, [runtime.contextOrFrameLookup(context, frame, "None"),runtime.contextOrFrameLookup(context, frame, "rrData"),runtime.contextOrFrameLookup(context, frame, "False"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrData")),"isDy")])), env.opts.autoescape);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/multipleRRProductTrays.j2"] , dependencies)